import { I18n } from '@calendly/i18n';
import { Table, Header, HeaderCell, Body, Row, Cell, EmptyState as EmptyStateContainer } from '@calendly/table';
import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NoGroup } from 'components/core/no_group';
import { sortOrderSelector, sortFieldSelector, filterTermSelector } from './selectors';
import { sortMigrations } from './slice';
const migrationIsTabletDownCss = "mdgt64o";
const migrationCss = "m16hby5e";
const Migration = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletDown = useDeviceType('isTabletDown');
  return <Component ref={ref} {...restProps} className={classNames(migrationCss, {
    [migrationIsTabletDownCss]: isTabletDown
  }, props.className)} />;
});
const noWrapCss = "n3h5bqu";
const NoWrap = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(noWrapCss, props.className)} />;
});
const EmptyState = () => {
  const filterTerm = useSelector(filterTermSelector);
  return <EmptyStateContainer>
      {filterTerm ? <>
          <BodyText weight="bold">{I18n.t('publisher.organization.empty.search')}</BodyText>
          <BodyText>{I18n.t('publisher.organization.empty.search_note_pending')}</BodyText>
        </> : I18n.t('publisher.organization.migrations.empty_state')}
    </EmptyStateContainer>;
};
export const MigratingUsersTable = ({
  migrations
}) => {
  const dispatch = useDispatch();
  const sortOrder = useSelector(sortOrderSelector);
  const sortField = useSelector(sortFieldSelector);
  const sortedColumn = {
    name: sortField,
    direction: sortOrder
  };
  return <div data-testid="migrating-users">
      <Table sortedColumn={sortedColumn} onSort={column => dispatch(sortMigrations(column))}>
        <Header>
          <HeaderCell columnName="email">
            {I18n.t('publisher.organization.headers.email')}
          </HeaderCell>
          <HeaderCell>
            <NoWrap>{I18n.t('publisher.organization.headers.group')}</NoWrap>
          </HeaderCell>
        </Header>
        <Body>
          {migrations.map(migration => <Row key={migration.id}>
              <Cell>
                <Migration>
                  <FullStoryExclude>
                    <Avatar size="big" letter={migration.avatar_letter} aria-hidden tabIndex={-1} />
                  </FullStoryExclude>
                  <BodyText><FullStoryMask>{migration.email}</FullStoryMask></BodyText>
                </Migration>
              </Cell>
              <Cell label={I18n.t('publisher.organization.headers.group')}>
                <NoGroup />
              </Cell>
            </Row>)}
          {migrations.length === 0 && <EmptyState />}
        </Body>
      </Table>
    </div>;
};

require("./table.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./table.js");